import { FCC } from "@/types/common";
import { Grid } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { TGetPartnerDto } from "@/api/services/main/partner/dtos/get-partner.dto";
import { PartnerTitle } from "@/features/partner/components/PartnerTitle";
import { PartnerFooterContainer } from "@/features/partner/components/PartnerFooterContainer";
import { Button } from "@/components/elements/Button";
import { IconEditor } from "@/assets/icons";
import { AppRoutes } from "@/routes/config";
import { getDynamicRoute } from "@/utils/url";
import { MenuNavigate } from "@/components/elements/MenuNavigate";
import { PartnerBasicInfo } from "@/features/partner/components/partner-detail/PartnerBasicInfo";
import { PartnerContactInfo } from "@/features/partner/components/partner-detail/PartnerContactInfo";
import { PartnerContractInfo } from "@/features/partner/components/partner-detail/PartnerContractInfo";
import { PartnerAdditionalInfo } from "@/features/partner/components/partner-detail/PartnerAdditionalInfo";

type TPartnerDetailContentProps = {
  partner: TGetPartnerDto;
};

export const PartnerDetailContent: FCC<TPartnerDetailContentProps> = ({ partner }) => {
  const navigate = useNavigate();
  const { partnerId } = useParams();
  const editRoute = getDynamicRoute(AppRoutes.partnerEdit, { partnerId });

  return (
    <>
      <PartnerTitle title={partner.partnerName} managementNumber={partner.managementNumber} createdAt={partner.createdAt} updatedAt={partner.updatedAt} />
      <Grid container sx={{ marginTop: 4 }}>
        <Grid item xs={12}>
          <MenuNavigate
            contents={[
              { title: "基本情報", content: <PartnerBasicInfo partner={partner} /> },
              { title: "担当者情報", content: <PartnerContactInfo partner={partner} /> },
              { title: "契約情報", content: <PartnerContractInfo partner={partner} /> },
              { title: "その他の情報", content: <PartnerAdditionalInfo partner={partner} /> },
            ]}
            contentAffix={
              <PartnerFooterContainer>
                <Button variant="outline" size="sm" onClick={() => navigate(editRoute)} startIcon={<IconEditor />}>
                  編集
                </Button>
              </PartnerFooterContainer>
            }
            contentWidth="900px"
          />
        </Grid>
      </Grid>
    </>
  );
};
